/* PavCon, LLC Proprietary.All rights reserved 2022 */
import { GlobalPageActions } from './app.actions.index';
import { GlobalUserState } from './models/user.model';

const INITIAL_STATE: AppState = {
  reloadData: null,
  collapsedMenu: false,
  selectedBaseId: null, // deprecated
  globalUser: {
    auth: null,
  },
  userLocation: {
    majcomUUID: null,
    baseUUID: null,
    unitUUID: null,
    changed: null,
    fileType: null,
  },
  settings: {
    isLoaded: false,
    list: [],
  },
};

export const NAMESPACE = 'APP';

export const AppActions = {
  INIT: `${NAMESPACE}.INIT`,
  RELOAD_DATA: `${NAMESPACE}.RELOAD_DATA`,
  COLLAPSED_MENU: `${NAMESPACE}.COLLAPSED_MENU`,
  WRITE_JWT_TOKENS: `${NAMESPACE}.JWT_TOKENS`,
  SET_SELECTED_BASE_ID: `${NAMESPACE}.SET_SELECTED_BASE_ID`,
  SET_USER_LOCATION: `${NAMESPACE}.SET_USER_LOCATION`,
  KEEP_CURRENT_STATE: `${NAMESPACE}.KEEP_CURRENT_STATE`,
  SET_SETTINGS: `${NAMESPACE}.SET_SETTINGS`,
};

export const AppReducer = (state: AppState = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case AppActions.INIT:
      // Return a new state object, don't mutate the existing one
      return { ...INITIAL_STATE };
    case AppActions.RELOAD_DATA:
      // Return new state object instead of mutating
      return {
        ...state,
        reloadData: action.payload,
      };
    case AppActions.COLLAPSED_MENU:
      return {
        ...state,
        collapsedMenu: action.payload,
      };
    case GlobalPageActions.WRITE_JWT_TOKENS:
      return {
        ...state,
        globalUser: {
          ...state.globalUser, // Preserve existing globalUser properties
          auth: action.payload,
        },
      };
    case AppActions.SET_SELECTED_BASE_ID:
      return {
        ...state,
        selectedBaseId: action.payload,
      };
    case AppActions.SET_USER_LOCATION:
      return {
        ...state,
        userLocation: action.payload ? { ...action.payload } : state.userLocation,
      };
    case AppActions.SET_SETTINGS:
      return {
        ...state,
        settings: action.payload ? { ...action.payload } : state.settings,
      };
    case AppActions.KEEP_CURRENT_STATE:
      // Return current state unchanged
      return state;
    default:
      return state;
  }
};

export interface AppState {
  globalUser: GlobalUserState;
  reloadData: boolean;
  collapsedMenu: boolean;
  selectedBaseId: string; // deprecated
  userLocation: {
    majcomUUID: string;
    baseUUID: string;
    unitUUID: string;
    changed: boolean;
    fileType: string;
  };
  settings: AppSettingState;
}
export interface AppSettingState {
  isLoaded: boolean;
  list: any;
}
/*Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon, LLC Proprietary.All rights reserved.
   2020 WARNING: this file may contain export controlled information.*/
